webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_data__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message__ = __webpack_require__(9);





var SOCKET_SERVER =  true ? 'https://sockets-ws-secure-v10.breezy.hr:443' : process.env.NODE_ENV === 'mm' ? 'https://sockets-ws-secure-v10-mm.breezy-hire.com' : 'http://localhost:8089';
var socket;


var init = function init(socketUrl) {

  if (socketUrl && socketUrl !== 'undefined') {
    SOCKET_SERVER = socketUrl;
  }
  console.log('socketUrl = ' + SOCKET_SERVER);

  socket = __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default.a.connect(SOCKET_SERVER, {
    transports: ['polling', 'websocket']
  });

  socket.on('connect', function (data) {
    console.log('socket connected');
  });

  socket.on('authenticationRequest', function (data) {
    console.log('authentication requested');
    __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].commit('SET_CONNECT', true);
  });

  socket.on('messageToCandidatePosted', function (data) {
    __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].commit('UPDATE_CONVERSATION', data);

    var play = __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].getters.play;
    var opened = __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].getters.opened;

    if (play) {
      document.querySelector('#ding').play();
    }
    if (!opened) {
      __WEBPACK_IMPORTED_MODULE_2__message__["a" /* default */].send({
        type: 'widget:open',
        payload: {
          open: true
        }
      });
    }
  });
};

var emit = function emit(message) {
  socket.emit(message);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  emit: emit
});

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_visitor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_socket__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_message__ = __webpack_require__(9);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);






var userSimple = function userSimple(user) {
  return {
    name: user.name,
    hex_color: user.hex_color,
    initial: user.initial,
    type: user.type,
    profile_photo_url: user.profile_photo_url || null
  };
};

var formatMessage = function formatMessage(message) {
  return {
    _id: new Date().getTime(),
    object: {
      body: message.body
    },
    attachments: message.attachments,
    status: 'sending',
    type: 'messageFromCandidatePosted'
  };
};

var state = {
  loading: false,
  inactive: false,
  connect: false,
  messenger: null,
  sendingMessage: false,
  visitor: {
    candidate: {
      name: '',
      email_address: '',
      resume: {},
      gdpr: {
        consent: false
      },
      start_id: null
    },
    options: {
      ding_muted: false,
      open: false
    }
  },
  conversation: []
};

var getters = {
  loading: function loading(state) {
    return state.loading;
  },
  sendingMessage: function sendingMessage(state) {
    return state.sendingMessage;
  },
  messenger: function messenger(state) {
    return state.messenger;
  },
  candidate: function candidate(state) {
    return state.visitor.candidate;
  },
  conversation: function conversation(state) {
    return state.conversation;
  },
  conversationLength: function conversationLength(state) {
    return function () {
      return state.conversation.length;
    };
  },
  play: function play(state) {
    return !state.visitor.options.ding_muted && (state.inactive || !state.visitor.options.open);
  },
  opened: function opened(state) {
    return state.visitor.options.open;
  },
  visitor: function visitor(state) {
    return state.visitor;
  }
};

var actions = {
  getMessenger: function getMessenger(context, companyId) {
    return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].getMessenger(companyId).then(function (messenger) {
      context.commit('setMessenger', messenger);
      return companyId;
    }).then(function (id) {
      var _v = __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].getVisitor(id);
      var data = {
        type: 'ready',
        payload: {
          firstVisit: _v.first_visit,
          open: _v.options.open
        }
      };
      __WEBPACK_IMPORTED_MODULE_6__services_message__["a" /* default */].send(data);

      if (_v.candidate._id) {
        __WEBPACK_IMPORTED_MODULE_5__services_socket__["a" /* default */].emit('authenticateCandidate', { candidate_id: _v.candidate._id });
      }
    });
  },
  getVisitor: function getVisitor(context, pageInfo) {
    var id = context.state.messenger._id;
    var updatedVisitor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].getVisitor(id), pageInfo);

    updatedVisitor.number_of_page_views++;
    updatedVisitor.time_on_current_page = new Date().getTime();


    __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].setVisitor(id, updatedVisitor);
    context.commit('setVisitor', updatedVisitor);
    if (updatedVisitor.candidate._id) {
      context.dispatch('getCandidateConversation');
    }
  },
  postCandidate: function postCandidate(context, _ref) {
    var positionId = _ref.positionId,
        candidate = _ref.candidate;

    return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].postCandidate({
      positionId: positionId,
      candidate: candidate
    }).then(function (candidate) {
      context.commit('updateVisitorCandidate', candidate);

      __WEBPACK_IMPORTED_MODULE_5__services_socket__["a" /* default */].emit('authenticateCandidate', { candidate_id: candidate._id });
      return true;
    }, function (e) {
      throw e;
    });
  },
  postMessageFromCandidate: function postMessageFromCandidate(context, message) {
    var formatedMessage = formatMessage(message);
    var _id = formatedMessage._id;
    context.commit('SENDING_MESSAGE');
    context.commit('UPDATE_CONVERSATION', formatedMessage);
    document.querySelector('#start').play();
    return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].postMessageFromCandidate({
      candidateId: context.state.visitor.candidate._id,
      message: message
    }).then(function (message) {
      context.commit('SENDING_MESSAGE_COMPLETE');
      setTimeout(function () {
        document.querySelector('#success').play();
        context.commit('UPDATE_CONVERSATION_STATE', {
          _id: _id,
          message: message,
          status: 'success'
        });
      }, 500);
    }, function (e) {
      document.querySelector('#error').play();
      context.commit('UPDATE_CONVERSATION_STATE', {
        _id: _id,
        message: message,
        status: 'error'
      });
    });
  },
  resendPostMessageFromCandidate: function resendPostMessageFromCandidate(context, message) {
    var _id = message._id;
    context.commit('SENDING_MESSAGE');
    var originalMessage = {
      attachments: message.attachments,
      body: message.object.body
    };
    document.querySelector('#start').play();
    return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].postMessageFromCandidate({
      candidateId: context.state.visitor.candidate._id,
      message: originalMessage
    }).then(function (message) {
      context.commit('SENDING_MESSAGE_COMPLETE');
      setTimeout(function () {
        document.querySelector('#success').play();
        context.commit('UPDATE_CONVERSATION_STATE', {
          _id: _id,
          message: message,
          status: 'success'
        });
      }, 500);
    }, function (e) {
      document.querySelector('#error').play();
      context.commit('UPDATE_CONVERSATION_STATE', {
        _id: _id,
        message: message,
        status: 'error'
      });
    });
  },
  getCandidateConversation: function getCandidateConversation(context) {
    var candidateId = context.state.visitor.candidate._id;
    var startId = context.state.visitor.candidate.start_id;
    context.commit('SET_LOADING', true);
    return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].getCandidateConversation(candidateId, startId).then(function (conversation) {
      context.commit('SET_CONVERSATION', conversation.reverse());
      context.commit('SET_LOADING', false);
      setTimeout(function () {
        document.querySelector('.conversation').scrollTop = document.querySelector('.conversation').scrollHeight;
      }, 1);
    }, function (e) {
      context.commit('SET_LOADING', false);
      console.log(e);
    });
  }
};

var mutations = {
  SET_CONNECT: function SET_CONNECT(state, connect) {
    state.connect = connect;
  },
  SENDING_MESSAGE: function SENDING_MESSAGE(state) {
    state.sendingMessage = true;
  },
  SENDING_MESSAGE_COMPLETE: function SENDING_MESSAGE_COMPLETE(state) {
    state.sendingMessage = false;
  },
  setMessenger: function setMessenger(state, messenger) {
    state.messenger = messenger;
  },
  setCandidateResume: function setCandidateResume(state, _ref2) {
    var file_name = _ref2.file_name,
        url = _ref2.url;

    state.visitor.candidate.resume.file_name = file_name;
    state.visitor.candidate.resume.url = url;
  },
  setVisitor: function setVisitor(state, visitor) {
    state.visitor = visitor;
  },

  UPDATE_VISITOR: function UPDATE_VISITOR(state, _ref3) {
    var breezy_portal = _ref3.breezy_portal,
        current_page_url = _ref3.current_page_url;

    state.visitor.breezy_portal = breezy_portal;
    state.visitor.current_page_url = current_page_url;
    state.visitor.time_on_current_page = new Date().getTime();
    state.visitor.number_of_page_views += 1;

    __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].setVisitor(state.messenger._id, state.visitor);
  },
  updateVisitorCandidate: function updateVisitorCandidate(state, candidate) {
    state.visitor.candidate = candidate;
    __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].setVisitor(state.messenger._id, state.visitor);
  },

  SET_INACTIVE: function SET_INACTIVE(state, _ref4) {
    var inactive = _ref4.inactive;

    state.inactive = inactive;
  },
  SET_LOADING: function SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_OPTION_OPEN: function SET_OPTION_OPEN(state, _ref5) {
    var open = _ref5.open;

    state.visitor.options.open = open;
    __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].setVisitor(state.messenger._id, state.visitor);
  },
  SET_CONVERSATION: function SET_CONVERSATION(state, conversation) {
    state.conversation = conversation;
  },
  UPDATE_CONVERSATION: function UPDATE_CONVERSATION(state, message) {
    if (state.conversation.length <= 0) {
      state.visitor.candidate.start_id = message._id;
      __WEBPACK_IMPORTED_MODULE_4__services_visitor__["a" /* default */].setVisitor(state.messenger._id, state.visitor);
    }
    state.conversation.push(message);
    setTimeout(function () {
      document.querySelector('.conversation').scrollTop = document.querySelector('.conversation').scrollHeight;
    }, 1);
  },
  UPDATE_CONVERSATION_STATE: function UPDATE_CONVERSATION_STATE(state, _ref6) {
    var _id = _ref6._id,
        message = _ref6.message,
        status = _ref6.status;

    var index = state.conversation.findIndex(function (message) {
      return message._id === _id;
    });
    state.conversation[index].status = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(129);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
var API_ROOT =  true ? 'https://app.breezy.hr/api' : process.env.NODE_ENV === 'mm' ? 'https://app.breezy-hire.com/api' : 'http://localhost:8080/api';


/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init(APP_BASE_URL) {
        if (APP_BASE_URL) {
            API_ROOT = APP_BASE_URL + "api";
        }
    },
    getMessenger: function getMessenger(companyId) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(API_ROOT + "/company/" + companyId + "/messenger").then(function (response) {
            return response.body;
        });
    },
    uploadResume: function uploadResume(file) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(API_ROOT + "/portal/upload", { file: file }).then(function (response) {
            return response.body;
        });
    },
    postCandidate: function postCandidate(_ref) {
        var positionId = _ref.positionId,
            candidate = _ref.candidate;

        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(API_ROOT + "/messenger/apply/" + positionId, candidate).then(function (response) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, candidate, response.body);
        }, function (e) {
            throw { error: 'postCandidate error' };
        });
    },
    postMessageFromCandidate: function postMessageFromCandidate(_ref2) {
        var candidateId = _ref2.candidateId,
            message = _ref2.message;

        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(API_ROOT + "/messenger/candidate/" + candidateId + "/conversation", message).then(function (response) {
            return response.body;
        }, function (e) {
            throw { error: 'postMessageFromCandidate error' };
        });
    },
    getCandidateConversation: function getCandidateConversation(candidateId, startId) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(API_ROOT + "/conversation/" + candidateId + "?start_id=" + startId).then(function (response) {
            return response.body.conversation || [];
        }, function (e) {
            throw { error: 'getCandidateConversation error' };
        });
    },
    getAPIRoot: function getAPIRoot() {
        return API_ROOT;
    }
});

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8322a5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c7b5c51",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('audio', {
    attrs: {
      "id": "ding",
      "src": _vm.assetsUrl + '/ding.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "start",
      "src": _vm.assetsUrl + '/send_start.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "error",
      "src": _vm.assetsUrl + '/send_error.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "success",
      "src": _vm.assetsUrl + '/send_success.mp3'
    }
  }), (_vm.messenger) ? _c('article', {
    style: ({
      backgroundColor: _vm.messenger.appearance.primary_color
    })
  }, [_c('header', [_c('div', {
    staticClass: "offset"
  }, [_c('avatar', {
    attrs: {
      "person": _vm.messenger.greeter,
      "borderColor": _vm.messenger.appearance.primary_color
    }
  }), _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v(_vm._s(_vm.messenger.greeter.name))])])], 1)]), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split-view hello"
  }, [_c('div', {
    staticClass: "split-view-top"
  }, [_c('transition-group', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll"
    }, {
      name: "prevent-parent-scroll",
      rawName: "v-prevent-parent-scroll"
    }],
    ref: "conversation",
    staticClass: "conversation",
    attrs: {
      "name": "message",
      "tag": "div"
    }
  }, [_c('message', {
    key: 'welcome',
    attrs: {
      "message": _vm.welcome
    }
  }), _vm._l((_vm.conversation), function(message, index) {
    return _c('message', {
      key: message._id,
      attrs: {
        "message": message
      }
    })
  })], 2)], 1), _c('div', {
    staticClass: "split-view-bottom"
  }, [_c('footer', [_c('loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _c('transition', {
    attrs: {
      "name": "form",
      "mode": "out-in"
    }
  }, [(_vm.chatEnabled || _vm.candidate._id) ? _c('div', {
    staticClass: "form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitMessage($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.body),
      expression: "message.body"
    }, {
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.message.body),
      expression: "message.body"
    }],
    ref: "message",
    attrs: {
      "placeholder": "Write a reply..."
    },
    domProps: {
      "value": (_vm.message.body)
    },
    on: {
      "keydown": _vm.checkSubmit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "body", $event.target.value)
      }
    }
  }), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "send-message",
    attrs: {
      "disabled": _vm.sendingMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])])])]), _c('div', {
    staticClass: "powered-by"
  }, [_c('span', [_vm._v("Powered by")]), (_vm.isPF) ? _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.peoplefluent.com/",
      "target": "_blank"
    }
  }, [_vm._v("PeopleFluent")]) : _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://breezy.hr/",
      "target": "_blank"
    }
  }, [_vm._v("breezy")])])]) : _c('div', {
    staticClass: "form"
  }, [(_vm.postingCandidateError) ? _c('div', [_c('p', [_vm._v("There was an error. Try again.")])]) : _vm._e(), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitCandidate($event)
      }
    }
  }, [_c('div', {
    staticClass: "field name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.name),
      expression: "candidate.name"
    }],
    class: {
      error: _vm.errors.invalid.name
    },
    attrs: {
      "id": "candidateName",
      "type": "text",
      "placeholder": "What's your name?"
    },
    domProps: {
      "value": (_vm.candidate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.candidate, "name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field email-resume"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.email_address),
      expression: "candidate.email_address"
    }],
    class: {
      error: _vm.errors.invalid.email_address
    },
    attrs: {
      "type": "email",
      "placeholder": "What's your email address?"
    },
    domProps: {
      "value": (_vm.candidate.email_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.candidate, "email_address", $event.target.value)
      }
    }
  })]), (_vm.messenger.gdprEnabled) ? _c('div', {
    staticClass: "field gdpr"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.candidate.gdpr.consent),
      expression: "candidate.gdpr.consent"
    }],
    class: {
      error: _vm.errors.invalid.consent
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.candidate.gdpr.consent) ? _vm._i(_vm.candidate.gdpr.consent, null) > -1 : (_vm.candidate.gdpr.consent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.candidate.gdpr.consent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.candidate.gdpr, "consent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.candidate.gdpr, "consent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.candidate.gdpr, "consent", $$c)
        }
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.messenger.templates.gdpr.body) + "  ")])]), _c('a', {
    attrs: {
      "href": _vm.privacyLink,
      "target": "_blank"
    }
  }, [_vm._v("View Privacy Notice")])]) : _vm._e(), _c('div', {
    staticClass: "actions clearfix"
  }, [_c('div', {
    staticClass: "button-group-left"
  }, [_c('button', {
    staticClass: "button-link resume",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$upload.select('resume')
      }
    }
  }, [(_vm.$upload.meta('resume').status === 'ready') ? _c('div', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Upload Resume")])]) : _vm._e(), (_vm.$upload.meta('resume').status === 'sending') ? _c('div', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }), _c('span', [_vm._v("Uploading...")])]) : _vm._e(), (_vm.$upload.meta('resume').status === 'complete') ? _c('div', [_c('i', {
    staticClass: "fa fa-file"
  }), _c('span', [_vm._v(_vm._s(_vm.candidate.resume.file_name))])]) : _vm._e()])]), _c('div', {
    staticClass: "button-group-right"
  }, [_c('button', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.postingCandidate
    }
  }, [(_vm.postingCandidate) ? _c('div', {
    staticClass: "sending"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Sending...")]), _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  })]) : _c('div', {
    staticClass: "not-sending"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Save & Send")]), _c('i', {
    staticClass: "fa fa-paper-plane"
  })])])])])])])])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bouncywrap"
  }, [_c('div', {
    staticClass: "dotcon dc1"
  }, [_c('div', {
    staticClass: "dot"
  })]), _c('div', {
    staticClass: "dotcon dc2"
  }, [_c('div', {
    staticClass: "dot"
  })]), _c('div', {
    staticClass: "dotcon dc3"
  }, [_c('div', {
    staticClass: "dot"
  })])])
}]}

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar",
    class: _vm.person.hex_color,
    style: ({
      boxShadow: '0 0 0 15px ' + _vm.borderColor
    }),
    attrs: {
      "data-initial": _vm.person.initial
    }
  }, [(_vm.person.profile_photo_url) ? _c('img', {
    attrs: {
      "src": _vm.person.profile_photo_url
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "message",
    class: _vm.messageClass
  }, [_c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedBody)
    }
  }), (_vm.message.status === 'sending') ? _c('small', [_vm._v("sending")]) : _vm._e(), (_vm.message.status === 'error') ? _c('small', {
    staticClass: "error",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("try again")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var lstore = window.localStorage;
var lsession = window.sessionStorage;
var STORAGE_KEY = 'bzy__visitor__';

/* harmony default export */ __webpack_exports__["a"] = ({
    getVisitor: function getVisitor(id) {
        var session = lsession.getItem(STORAGE_KEY + id);
        var visitor = lstore.getItem(STORAGE_KEY + id);
        if (visitor) {
            visitor = JSON.parse(visitor);
            visitor.first_visit = false;
        } else {
            visitor = {
                first_visit: true,
                browser_language: navigator.language,
                number_of_page_views: 0,
                time_on_current_page: new Date().getTime(),
                number_of_visits: 0,
                candidate: {
                    email_address: '',
                    resume: {},
                    start_id: null
                },
                options: {
                    ding_muted: false,
                    open: false
                }
            };
        }
        if (!session) {
            visitor.number_of_visits++;
            this.setSession(id);
        }

        return visitor;
    },
    setVisitor: function setVisitor(id, visitor) {
        visitor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(visitor);
        var data = {
            type: 'update',
            payload: visitor
        };
        parent.postMessage(data, '*');
        lstore.setItem(STORAGE_KEY + id, visitor);
    },
    setSession: function setSession(id) {
        lsession.setItem(STORAGE_KEY + id, new Date().getTime());
    }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Hello__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:companyId',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Hello___default.a
  }]
}));

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(123),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_socket__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a
  },
  data: function data() {
    return {
      companyId: this.$route.params.companyId,
      referrer: this.$route.query.page,
      assetsUrl:  true ? '/breezy-widget/static' : '/static'
    };
  },
  created: function created() {
    console.log('created', this.$route.query);
    __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].init(this.$route.query.APP_BASE_URL);
    __WEBPACK_IMPORTED_MODULE_2__services_socket__["a" /* default */].init(this.$route.query.socketUrl);
    this.$store.dispatch('getMessenger', this.companyId);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['messenger', 'candidate'])),
  methods: {}
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'avatar',
  props: ['person', 'borderColor'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  props: ['show'],
  data: function data() {
    return {};
  },

  computed: {}
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
  if (!text) {
    text = href;
  }

  if (text && text.length > 27) {
    text = text.substring(0, 27) + '...';
  }
  return '<a href="' + href + '" target="_blank">' + text + '</a>';
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'message',
  props: ['message'],
  data: function data() {
    return {};
  },

  computed: {
    formattedBody: function formattedBody() {
      var formattedBody = marked(this.message.object.body || '', { renderer: renderer });

      return formattedBody;
    },
    messageClass: function messageClass() {
      var type = 'user';
      if (this.message.type === 'messageFromCandidatePosted') {
        type = 'candidate';
      } else if (this.message.type === 'autoResponse') {
        type = 'auto';
      }
      return type;
    }
  },
  methods: {
    resend: function resend() {
      this.$store.dispatch('resendPostMessageFromCandidate', this.message);
    }
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Message__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__(12);








var isEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

var replyTime = {
  day: 'They\'ll typically reply in a day',
  minutes: 'They\'ll typically reply in a few minutes',
  hours: 'They\'ll typically reply in a few hours',
  asap: 'They\'ll reply as soon as possible.'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading___default.a,
    message: __WEBPACK_IMPORTED_MODULE_2__components_Message___default.a
  },
  data: function data() {
    return {
      isPF: false,
      chatEnabled: true,
      postingCandidate: false,
      postingCandidateError: false,
      welcome: {
        object: {
          body: ''
        },
        type: 'messageToCandidatePosted'
      },
      message: {
        body: '',
        attachments: []
      },
      stored_message: {
        body: '',
        attachments: []
      },
      errors: {
        prevent: false,
        invalid: {
          email_address: false,
          resume: false,
          consent: false
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['messenger', 'templates', 'candidate', 'conversation', 'visitor', 'sendingMessage', 'loading']), {
    privacyLink: function privacyLink() {
      return 'https://' + this.messenger.company.friendly_id + '.' + this.$route.query.portalDomain + '/privacy-notice';
    }
  }),
  created: function created() {

    this.isPF = this.$route.query.isPF ? eval(this.$route.query.isPF) : false;

    var API_ROOT = __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].getAPIRoot();
    var UPLOAD_PATH = API_ROOT + '/portal/' + this.messenger.company.friendly_id + '/upload/resume';

    this.$upload.new('resume', {
      url: UPLOAD_PATH,
      extensions: ['abw', 'djvu', 'doc', 'docx', 'html', 'lwp', 'md', 'odt', 'pages', 'pages.zip', 'pdf', 'rst', 'rtf', 'sdw', 'tex', 'txt', 'wpd', 'wps', 'zabw'],
      maxSizePerFile: this.isPF ? 4096 : 1024,
      onSuccess: function onSuccess(res) {
        this.$store.commit('setCandidateResume', {
          file_name: res.body.file_name,
          url: res.body.url
        });
      },
      onError: function onError(err) {
        console.log('file upload err', err);
      },
      onSelect: function onSelect(files) {}
    });

    if (this.candidate._id) {
      this.$store.dispatch('getCandidateConversation');
    }
  },
  mounted: function mounted() {
    this.welcome.object.body = this.messenger.templates.default.body;
  },

  watch: {
    'candidate.email_address': function candidateEmail_address(val) {
      if (isEmail.test(val)) {
        this.errors.invalid.email_address = false;
      }
    }
  },
  methods: {
    checkSubmit: function checkSubmit(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.submitMessage();
      }
    },
    submitMessage: function submitMessage() {
      if (this.message.body.trim().length === 0) return;

      this.message.body = this.message.body.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');

      if (this.candidate._id) {
        this.$store.dispatch('postMessageFromCandidate', this.message);
      } else {
        this.chatEnabled = false;
        this.stored_message.body = this.message.body;
        setTimeout(function () {
          document.querySelector('#candidateName').focus();
        }, 1000);
      }
      this.message = {
        body: '',
        attachments: []
      };
    },
    submitCandidate: function submitCandidate(e) {
      var _this = this;

      this.errors.prevent = false;
      if (this.candidate.name) {
        this.errors.invalid.name = false;
      } else {
        this.errors.invalid.name = true;
        this.errors.prevent = true;
      }

      if (this.candidate.email_address) {
        this.errors.invalid.email_address = false;
      } else {
        this.errors.invalid.email_address = true;
        this.errors.prevent = true;
      }

      if (this.messenger.gdprEnabled) {
        if (this.candidate.gdpr.consent) {
          this.errors.invalid.consent = false;
        } else {
          this.errors.invalid.consent = true;
          this.errors.prevent = true;
        }
      }

      if (this.errors.prevent) return;

      this.postingCandidate = true;
      this.postingCandidateError = false;

      this.$store.dispatch('postCandidate', {
        positionId: this.messenger.position_id,
        candidate: this.candidate
      }).then(function (result) {
        _this.postingCandidate = false;
        _this.$store.dispatch('postMessageFromCandidate', _this.stored_message).then(function () {
          _this.$store.commit('UPDATE_CONVERSATION', {
            _id: new Date().getTime(),
            object: {
              body: replyTime[_this.messenger.reply_time]
            },
            type: 'autoResponse'
          });
        });
      }, function (e) {
        _this.postingCandidate = false;
        _this.postingCandidateError = true;
      });
    }
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_upload__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websanova_vue_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_tooltip__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_chat_scroll__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_chat_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_chat_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_prevent_parent_scroll__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_prevent_parent_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_prevent_parent_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_autosize__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_data__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_socket__ = __webpack_require__(10);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__services_message__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__websanova_vue_upload___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_v_tooltip__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_chat_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_prevent_parent_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_autosize___default.a);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store_data__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_data__ = __webpack_require__(11);




var parseMessage = function parseMessage(event) {
  var message;
  try {
    message = JSON.parse(event.data);
  } catch (e) {
    message = event;
  }

  switch (message.type) {
    case 'visitor:init':
      __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].dispatch('getVisitor', message.payload);
      break;
    case 'visitor:update':
      __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].commit('UPDATE_VISITOR', message.payload);
      break;
    case 'messenger:active':
      __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].commit('SET_INACTIVE', message.payload);
      break;
    case 'messenger:open':
      if (message.payload.firstVisit) {
        document.querySelector('#ding').play();
      }
      __WEBPACK_IMPORTED_MODULE_1__store_data__["a" /* default */].commit('SET_OPTION_OPEN', message.payload);
      break;
    default:
      console.log('"' + message.type + '" not found');
  }
};

var Message = {
  install: function install(Vue, options) {
    window.addEventListener('message', parseMessage, false);
  },
  send: function send(data) {
    parent.postMessage(data, '*');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[59]);


// WEBPACK FOOTER //
// breezy-widget/static/js/app.1b9dbaf363311cf1c952.js